import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';
import { ISOFormat } from '../enums';

interface WallClockMonth {
    value: string;
}

function WallClockMonth(luxon: DateTime): WallClockMonth {
    return type.create(WallClockMonth, {
        value: luxon.toFormat(ISOFormat.Month),
    });
}

export default WallClockMonth;
